import { useEffect, useRef } from 'react';

/**
 * Предоставляет декларативный setInterval
 *
 * @param callback - функция, которая будет вызываться каждые `delay` ms.
 * @param delay - задержка в ms. Установить `null` чтобы поставить на паузу.
 */

export const useInterval = (callback, delay) => {
  const savedCallbackRef = useRef();
  useEffect(() => {
    savedCallbackRef.current = callback;
  }, [callback]);
  useEffect(() => {
    const handler = (...args) => savedCallbackRef.current(...args);
    if (delay === null) return;
    const intervalId = setInterval(handler, delay);
    return () => clearInterval(intervalId);
  }, [delay]);
};